import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useLocation, useNavigate } from 'react-router-dom';
import { normalizeLanguage } from './config';

const STORAGE_KEY = 'i18nextLng';

function readStoredLanguage(): string | null {
    try {
        return window.localStorage.getItem(STORAGE_KEY);
    } catch {
        return null;
    }
}

function storeLanguage(language: string) {
    try {
        window.localStorage.setItem(STORAGE_KEY, language);
    } catch {
        return;
    }
}

export default function LanguageManager() {
    const { i18n } = useTranslation();
    const location = useLocation();
    const navigate = useNavigate();
    const queryLanguage = new URLSearchParams(location.search).get('lang');

    useEffect(() => {
        const current = normalizeLanguage(i18n.language);

        if (queryLanguage) {
            const target = normalizeLanguage(queryLanguage);
            if (target !== current) void i18n.changeLanguage(target);
            return;
        }

        const detected = normalizeLanguage(readStoredLanguage() ?? navigator.language);
        const params = new URLSearchParams(location.search);
        params.set('lang', detected);
        navigate({ pathname: location.pathname, search: `?${params.toString()}`, hash: location.hash }, { replace: true, preventScrollReset: true });
    }, [queryLanguage, i18n, location.pathname, location.search, location.hash, navigate]);

    useEffect(() => {
        const language = normalizeLanguage(i18n.language);
        document.documentElement.lang = language;
        storeLanguage(language);
    }, [i18n.language]);

    return null;
}
